import React, {useRef} from "react";
import {Button, Input, Label} from "reactstrap";

import {playNotificationSound, previewNotificationSound} from "../../../helpers/notificationSound";
import {useNotificationSettings} from "../../../hooks/useNotificationSettings";
import {NOTIFICATION_SOUNDS} from "../../../common/utils/notification-sounds.registry";

const NotificationSoundSettings: React.FC = () => {
    const {volume, soundId, setVolume, setSoundId} = useNotificationSettings();
    const lastNonZero = useRef(volume > 0 ? volume : 0.5);

    const onVolumeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const v = Number(e.target.value) / 100;
        if (v > 0) lastNonZero.current = v;
        setVolume(v);
    };

    const toggleMute = () => {
        if (volume > 0) {
            lastNonZero.current = volume;
            setVolume(0);
        } else {
            setVolume(lastNonZero.current);
        }
    };

    const onSoundChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const id = e.target.value;
        setSoundId(id);
        previewNotificationSound(id);
    };

    const icon =
        volume === 0 ? "bx-volume-mute" : volume < 0.5 ? "bx-volume-low" : "bx-volume-full";

    return (
        <>
            <div className="mt-4 mb-3">
                <Label id="notification-volume-range"
                       className="form-label d-flex justify-content-between align-items-center mb-3">
                    <span>Notification volume</span>
                    <span className="text-muted">{Math.round(volume * 100)}%</span>
                </Label>
                <div className="d-flex align-items-center gap-2">
                    <i
                        className={`bx ${icon} font-size-20`}
                        role="button"
                        title={volume === 0 ? "Unmute" : "Mute"}
                        onClick={toggleMute}
                    />
                    <Input
                        type="range"
                        min={0}
                        max={100}
                        step={1}
                        value={Math.round(volume * 100)}
                        onChange={onVolumeChange}
                        onMouseUp={() => playNotificationSound()}
                        onTouchEnd={() => playNotificationSound()}
                        aria-label="Notification volume"
                    />
                </div>
            </div>

            <div className="mt-4 mb-3">
                <Label className="form-label mb-3">Notification sound</Label>
                <div className="d-flex align-items-center gap-2">
                    <Input
                        type="select"
                        value={soundId}
                        onChange={onSoundChange}
                        aria-label="Notification sound"
                    >
                        {NOTIFICATION_SOUNDS.map((s) => (
                            <option key={s.id} value={s.id}>
                                {s.label}
                            </option>
                        ))}
                    </Input>
                    <Button color="light"
                            title="Play sample"
                            onClick={() => previewNotificationSound(soundId)}><i
                        className="bx bx-play font-size-16"/>
                    </Button>
                </div>
            </div>
        </>
    );
};

export default NotificationSoundSettings;